import React, {ReactElement} from 'react';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {BackButtonAction} from '../../core/utils/string.util';
import {pageName} from '../../lib/constants';
import {setPageName} from '../../lib/tagmanager';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../redux/globalSlice';

const TermsAndCondition = (): ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    setPageName(pageName.termsConditionPage);
    dispatch(setAppBarTitle('Terms & conditions'));
    dispatch(setBackNavEnabled(true));
    setBackNavAction(BackButtonAction.TO_HOME);
    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      setBackNavAction(undefined);
    };
  }, []);

  return (
    <div className="p-4 text-center">
      <h2 className="text-big">Terms & conditions</h2>
      <div className="mt-4 text-left text-sm font-roboto">
        <h2 className="text-sm mb-2">
          <u>Privacy Policy</u>
        </h2>
        <p>
          This document is an electronic record in terms of Information
          Technology Act, 2000 and rules there under as applicable and the
          amended provisions pertaining to electronic records in various
          statutes as amended by the Information Technology Act, 2000. This
          electronic record is generated by a computer system and does not
          require any physical or digital signatures.
        </p>
        <br />
        <p>
          This Privacy Policy document (“Privacy Policy”) is published in
          accordance with the provisions of Rule 3 (1) of the Information
          Technology (Intermediaries guidelines) Rules, 2011 that require
          publishing the rules and regulations and privacy policy for access or
          usage of www.buddy.maxfashion.in website
        </p>
        <br />
        <p>
          Lifestyle International Private Limited, Max Retail Division, a
          company incorporated in India under the provisions of Companies Act,
          1956 having its registered office at 77 Town Centre, Building No. 3,
          West Wing, Off HAL Airport Road, Yamlur P.O., Bangalore – 560037,
          through its Max Retail Division (referred to herein as
          &aposLifestyle&apos, &aposwe&apos, &aposour&apos or &aposus&apos) is
          in the business of operating retail stores across India for sale of
          apparels, footwear, fashion accessories, furniture’s, gift items, etc,
          inter-alia, under brands viz., “Lifestyle”, “Max” “Home Centre” and
          “Easybuy” format/concepts. This Privacy Policy pertains to your
          transactions made for the self-checkout services (“Check-out
          Services”) on the website www.buddy.maxfashion.in (“Website”) subject
          to the Terms of Use mentioned on the Website. We are committed to
          protecting your privacy. This Privacy Policy discloses the privacy
          practices for the Website. This Privacy Policy describes the ways in
          which we collect, store, use and protect the information collected due
          to your use of Website. By accessing the Website and/or providing us
          with your information you expressly consent to us processing your
          personal information in accordance with the terms of the Privacy
          Policy. We reserve the right to delete, modify, change or supplement
          the content of the Website, Terms of Use and/or this Privacy Policy at
          any time for any reason without prior notification, and will use
          reasonable efforts to include up-to-date and accurate information on
          the Website.{' '}
        </p>
        <br />
        <p className="font-bold">
          PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY ACCESSING OR USING OUR
          WEBSITE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO
          BE BOUND TO ALL THE TERMS OF THIS PRIVACY POLICY AND OUR WEBSITE TERMS
          OF USE AND ANY OTHER TERMS AND CONDITION ON THE WEBSITE. IF YOU DO NOT
          AGREE TO THESE TERMS ANY OTHER TERMS AND CONDITION ON THE WEBSITE, YOU
          ARE REQUESTED EXIT THIS PAGE AND NOT TO ACCESS OR USE THE WEBSITE.
        </p>
        <br />
        <p>
          1. <b>Change in the Privacy Policy</b>: Changes in law or changes in
          Lifestyle’s business may require changes to be made to the terms of
          this Privacy Policy from time to time so Lifestyle encourages you to
          review this Privacy Policy periodically or on every occasion You visit
          or use the Website for any such changes. It is your responsibility to
          carefully read, agree with the Privacy Policy on each occasion you use
          the Website and your continued use of the Website shall signify your
          acceptance to be bound by the latest Privacy Policy.
        </p>
        <br />
        <h3>
          <b>Information Collected</b>
        </h3>
        <br />
        <p>
          The Information we collect about you may be broadly described in
          following categories:{' '}
        </p>
        <br />
        <p>
          1. <b>Personal Information:</b> Your name, address, phone number,
          email address, user name, password, billing and credit card
          information, order history, feedback, IP address and location, digital
          device name, type and configuration, details relating to your download
          of Publications via the service (including details relating to the
          time of the download, any interruptions, and the success or failure of
          the downloads), the URL from which you accessed the Website,
          demographic information, and other such &apos Personal Information
          &apos.
        </p>
        <br />
        <p>
          2.<b> One-Time Password through SMS/Text Messages/ WhatsApp :</b> For
          the purposes of enabling your payment through third party payment
          gateway systems or for any other verification, we shall collect data
          from SMS/ text messages / WhatsApp received on your device subject to
          necessary device permissions for the purposes of (i) issuing and
          receiving one-time passwords and other device verification to
          enable/verify the transaction, and (ii) automatically filling
          verification details during financial transactions, either through us
          or a third-party service provider, in accordance with applicable law
          with a sole objective to enable/verify the transaction. We do not
          share or transfer SMS/ text message/WhatsApp data to any third party
          other than as provided under this Privacy Policy.
        </p>
        <br />
        <p>
          3. <b>General Information:</b> We may also receive more general
          information from you as a result of your visits to, and use of, the
          Website. This general information does not identify you personally,
          and can include information such as your IP address, the length of
          time you spend on the Website, your browsing history, and other such{' '}
          &apos General Information &apos
        </p>
        <br />
        <p>
          Personal Information and General Information shall collectively and
          individually be referred to as “Information”.
        </p>
        <br />
        <h3>All the above Information is collected for:</h3>
        <br />
        <p>1. Better servicing and account maintenance;</p>
        <p>
          2. To seek your feedback or to contact you in relation to those
          services
        </p>
        <p>
          3. Making the offerings more relevant to the you and your desires
          ensuring no spam mails go through;
        </p>
        <p>
          4. Keeping track of the transactions, to help in case of any dispute
          situations; dealing with enquiries, requests or complaints and other
          customer care related activities; and all other general administrative
          and business purposes; marketing products and services; carrying out
          any activity in connection with a legal, governmental or regulatory
          requirement or in connection with legal proceedings, crime or fraud
          prevention, detection or prosecution;
        </p>
        <p>
          5. To effectively administer and fulfil our obligations under any
          agreement (if any) we may have with you;
        </p>
        <br />
        <p>
          To collect the Information, we shall use channels such as physical
          forms, call center, Website (including cookies), emails, promotional
          offers, surveys and mailers. Participation in some of these channels
          is optional but you may be required to provide your Information in
          order to participate. We are not liable to verify the authenticity or
          accuracy of any Information we collect from you
        </p>
        <br />
        <p>
          From time to time we may ask you to update your contact & Information
          with us on the Website, contact center or through any other approved
          channels. This is to help keep you updated on services, any changes in
          the services and its enhancements. We will not be liable for any
          failure or default to notify you of any service, any change in service
          or its enhancement if you fail to update such Information in a timely
          manner.
        </p>
        <br />
        <h3>
          <b>Access to Information:</b>
        </h3>
        <br />
        <p>
          Lifestyle collects your Personal Information to enable us, amongst
          other things, to provide the Website to you. We take all steps
          reasonably necessary to protect against the unauthorised access, use,
          alteration, disclosure or destruction of Personal Information.
        </p>
        <br />
        <h3>Information Storage & Sharing:</h3>
        <br />
        <p>
          Any Information that we collect and store that is personally
          identifiable is protected using appropriate means, and although
          Lifestyle does so, it will not be held responsible for any
          unauthorised access by third parties.
        </p>
        <br />
        <p>
          All Information shall be stored by us or one or more of our vendors,
          who will be bound by a non-disclosure agreement with us. We reserve
          the rights to hold your Information indefinitely to enable the Website
          services to you.
        </p>
        <br />
        <p>
          You agree that all Personal Information shall be retained till such
          time required for the purpose of providing you services or required
          under applicable law, whichever is later. Non-Personal Information
          will be retained indefinitely.{' '}
        </p>
        <br />
        <p>
          We may share or disclose the Information collected and received under
          this Privacy Policy:
        </p>
        <br />
        <p>
          1. With one or more of our corporate entities and affiliates globally
          to help detect and prevent identity theft, fraud and other potentially
          illegal acts; correlate related or multiple accounts to prevent abuse
          of our services; and to facilitate joint or co-branded services as
          part of service offered to you through Website.{' '}
        </p>
        <p>
          2. As required by law, such as to comply with a subpoena, or similar
          legal process, etc.;
        </p>
        <p>
          3. When we believe in good faith that disclosure is necessary to
          protect our rights and interests, protect your safety or the safety of
          others, investigate fraud, or respond to a government request and the
          like;
        </p>
        <p>
          4. With our trusted services providers who work on our behalf, do not
          have an independent use of the Information we disclose to them, and
          have agreed to adhere to the rules set forth in this Privacy Policy.
        </p>
        <p>
          5. If any of the entities or affiliates globally or group company is
          involved in a merger, acquisition, or sale of all or a portion of its
          assets, the business entity that consequently acquires such
          Information will receive and store the same as per this Privacy
          Policy.
          <p>
            6. To our our group companies anywhere in the world for general
            administrative and business purposes which may include:
          </p>
        </p>
        <br />
        <p className="ml-4">
          <p>
            {' '}
            1. Lifestyle’s use of other companies and/or individuals to perform
            functions on its behalf (e.g. processing credit card payments,
            providing customer service, domestic or international data
            hosting/storage services on cloud or otherwise), and in such
            circumstances these companies or individuals will be provided access
            to only such Personal Information required to fulfill their
            functions (and only on the agreement that they not use your Personal
            Information for any other purposes); and
          </p>
          <p>
            2. Purposes intended to deliver publications to you, verify your
            account information, verify access to publications, determine
            whether you meet the minimum system requirements for use of the
            service, provide you tailored content and instructions, targeted
            promotions, provide customer support, and seek your input regarding
            LIFESTYLE.
          </p>
        </p>
        <br />
        <p>
          Apart from the forgoing’s, we may use third party service providers to
          help us operate our business, or administer activities on our behalf,
          such as sending out newsletters or surveys and the like. We will only
          share your information with these third parties for those limited
          purposes.
        </p>
        <br />{' '}
        <p>
          We may also share your Information with third parties under a
          confidentiality agreement which inter alia provides for that such
          third parties not disclosing the Information further unless such
          disclosure is for the purpose. However, Lifestyle is not responsible
          for any breach of security or for any actions of any third parties
          that receive Your Personal Information. Lifestyle is not liable for
          any loss or injury caused to You as a result of You providing Your
          Personal Information to third party (including any third party
          websites, even if links to such third party websites are provided on
          the Website).
        </p>
        <br />{' '}
        <p>
          You may receive promotional offers, campaign details, company news,
          updates, related product or service Information, etc by email among
          other means. If you have opted to receive promotional offers there
          will be unsubscribe options with all such category of offers and you
          may choose to unsubscribe from such offers at any time by following
          the instructions included at the bottom of each email, or by
          contacting us via our Website.
        </p>
        <br />{' '}
        <p>
          Selectively, you may also receive various offers via your mobile
          number or postal mail. We also contact you via email for
          administrative purposes, such as change notifications or if we update
          our Privacy Policy. While you can elect to stop receiving email for
          promotional offers (as described above), you cannot unsubscribe from
          these administrative messages while enrolled on the Website.
        </p>
        <br />{' '}
        <p>
          Our customer care department may also contact you in response to an
          inquiry you submit. Customer care may also contact you with regard to
          a particular problem that may have occurred with your account or with
          an offer in which you may have participated. We may use this
          Information to learn more about your participation in the Website and
          make it more relevant to your interests.
        </p>
        <br />{' '}
        <p>
          <b>Information access by member:</b>
        </p>
        <br />{' '}
        <p>
          We respect your privacy and are committed to ensuring the
          confidentiality of your Information with us. We may contact you with
          useful Information on products and services through our telemarketing
          / tele calling activities, which may be beneficial for you. However,
          if you do not wish to be contacted through our telemarketing calls or
          messages, we request you to kindly register at our call center and
          give details of the telephone on which you do not wish to be
          contacted. However, we reserve the right to contact you through tele
          calling for services related to your account. Further, we are
          committed to follow the laws laid out with regards to tele calling and
          telemarketing and, follow the guidelines set by any regulatory
          authority like TRAI in cases of Do Not Disturb (“DND”) policy or any
          such similar rules which may be in force. Once you have registered for
          any such DND policy, your telephone number(s) will be removed from all
          our telemarketing calling lists within 30 working days. We will ensure
          that you do not get any further telemarketing calls on the telephone
          number(s) that you have registered.
        </p>
        <br />
        <p>
          <b>Voice Call Recordings at Contact Centre:</b>
        </p>
        <br />
        <p>
          With a view to providing the best possible service to its customers,
          we will be:
        </p>
        <br />
        <p>
          1. Recording voice calls made to our customer care with a view to
          better provide our services
        </p>
        <p>2. Monitoring the voice calls recorded; and </p>
        <p>
          3. Overseeing the services furnished by the customer call centers.
        </p>
        <p>
          4. Sharing with one or more our affiliate companies, all or any
          particular call recordings received from those customers who have been
          enrolled with us on the Website and/or a report with details of the
          complaints, if any, received by you or the customer. The sharing of
          voice recordings received from the call centers with our affiliate
          companies will be done in due compliance of applicable privacy laws.
        </p>
        <br />
        <p>All of the aforesaid activities are done, inter alia, to:</p>
        <br />
        <p>1. Improve customer satisfaction</p>
        <p>2. Assure quality management and customer experience</p>
        <p>
          3. Identify and analyze the patterns and the types of
          requests/complaints raised by customers
        </p>
        <p>
          4. Initiate remedial measures to prevent the re-occurrence of such
          complaints/issues
        </p>
        <p>5. Retain a recording of the voice calls; and</p>
        <p>
          6. Support any transactions that take place over the phone and/or if
          there is a dispute
        </p>
        <br />
        <p>
          <b>Links to Other Sites:</b>
        </p>
        <br />
        <p>
          The Website or any activities made on the Website may contain features
          which link to other websites that may collect Information about you.
          We are not responsible for the privacy practices or the content of
          those linked websites. In addition, such other websites may contain
          certain product and service offerings which are carried out
          independently by such third party websites. We are neither responsible
          for the working of such third-party websites nor do we warrant or nor
          do we make any assurances of the existence, adequacy or functioning of
          security practices of any such third party websites.
        </p>
        <br />
        <p>
          <b>Cookies: </b>
        </p>
        <br />
        <p>
          We may use cookies or other technologies on the Website. Cookies are
          small files or records that we may place on your web browser for
          collecting Information about your activities on the Website, preparing
          reports, assessing trends, and otherwise monitoring the way in which
          the Website is being used. This is intended to enhance convenience for
          you, and to assist us to run an efficient operation. By accepting
          these Terms and Privacy Policy, you confirm your consent to our use of
          cookies, and other such technologies, for these purposes.
        </p>
        <br />
        <p>
          <b>Treatment of Personal Information:</b>
        </p>
        <br />
        <p>
          For the purpose of Single- Sign-On, certain Information is stored
          centrally in a database and is available to our affiliates or group
          companies and service providers connected with the operation of
          Website.
        </p>
        <br />
        <p>
          Lifestyle collects your Personal Information to enable us, amongst
          other things, to provide it for rendering the services to you. We take
          all steps reasonably necessary to protect against the unauthorised
          access, use, alteration, disclosure or destruction of Personal
          Information. If Lifestyle is sold to a third party, or Lifestyle
          otherwise becomes subject to a merger, consolidation or acquisition,
          it would become necessary for us to transfer your Personal Information
          to a third party, and in such case Lifestyle would require that the
          third party handles your Personal Information with no less care than
          taken by us.
        </p>
        <br />
        <p>
          The email address you provide while creating the Single Sign-On will
          only be used to send you information and updates related to the
          products; and to respond to your enquiries and requests. If you decide
          to opt-in to our mailing list, you&apos ll &apos receive emails that
          may include company news, updates, related product or service
          information, etc. You can unsubscribe from our email list at any time
          by following the instructions included at the bottom of each email, or
          by contacting us via Website.
        </p>
        <br />
        <p>
          We maintain physical, electronic and procedural safeguards to protect
          the Information. Specific employees only are authorized to access the
          Information on a need to know basis for business purposes only.
        </p>
        <br />{' '}
        <p>
          To keep your Personal Information safe, we ensure that sensitive and
          private data exchanges between you and Lifestyle happen over a Secure
          Sockets Layer (SSL)-secured communication channel, and are encrypted
          and protected with digital signatures. SSL-secured communication
          channels are specially designed to protect personal and sensitive
          Information (payment details), which is sent over the internet.{' '}
        </p>
        <br />{' '}
        <p>
          If you choose a payment gateway to complete any transaction on third
          party portal provided on the Website then Your credit card data may be
          stored in compliance with industry standards/ recommended data
          security standard for security of financial Information such as the
          Payment Card Industry Data Security Standard (PCI-DSS).
        </p>
        <br />{' '}
        <p>
          You may review or update the Personal Information that MAX FASHION
          holds in respect of your account by contacting Max fashion at
          help.in@maxfashion.com or Call us on 1800-123-1444
        </p>
        <br />{' '}
        <p>
          <b>Treatment of General Information: </b>
        </p>
        <br />{' '}
        <p>
          Lifestyle also collects your General Information to allow us, amongst
          other things, to better understand our users and improve the layout
          and functionality of the Website. Lifestyle may use and disclose
          anonymous Information, including aggregate anonymous Information
          derived from your Personal Information, to inform publishers,
          partners, trusted affiliates, advertisers, and other interested
          parties as to the usage habits or characteristics of Lifestyle
          customer base, and to serve any other business purposes.
        </p>
        <br />{' '}
        <p>
          <b>Opt out rights:</b>
        </p>
        <br />{' '}
        <p>
          In the event, you do not wish that your Information to be used for the
          purposes mentioned herein or you wish to withdraw consent for use of
          your Information please e-mail us at help.in@maxfashion.com or call us
          on 1800-123-1444. In such events, we may not be in a position to
          provide you any benefits or Services. Also, in case you choose to not
          share your name and/or mobile number, your registration from the
          Website will be terminated.
        </p>
        <br />{' '}
        <p>
          <b>Anti-Spam Policy: </b>
        </p>
        <br />{' '}
        <p>
          Since email is an integral part for the Service being rendered, your
          sharing of email contact with us allows us to share the offers and
          promotions relating to the Checkout Service or Website via email with
          you. If you later decide not to receive any offers and or promotions
          relating to the Checkout Service or Website, you may unsubscribe by
          communicating to us. Please note that opting not to receive email does
          not exempt you from receiving administrative emails that include but
          are not limited to, notices about membership status changes or
          alterations to our terms of Service or this Privacy Policy any other
          service requests.
        </p>
        <br />{' '}
        <p>
          <b>Data Accuracy, Verification and Supplementation: </b>
        </p>
        <br />{' '}
        <p>
          It is in your interest and it is our objective, for us to have
          accurate, current and complete Information concerning you and your
          account. We have strict procedures that our employees abide by to meet
          this objective. While some procedures are required by central, state
          or RBI regulations, we have implemented additional procedures to
          maintain accurate, correct and complete financial Information,
          including processes to update Information and remove outdated
          Information. If you believe that we have incorrect Information about
          you or your accounts, please intimate us. We will correct any
          erroneous Information as soon as possible. Data verification involves
          the use of third-party data processing services to standardize and
          clean your provided Information so that it is easily identified and
          accessed in our database.
        </p>
        <br />{' '}
        <p>
          Guarding your own Information: We recommend that you take the
          following precautions to guard against the disclosure and unauthorized
          use of your Information:
        </p>
        <br />{' '}
        <p className="ml-4">
          <p>
            1. never provide Information that can be used to access your account
            over the phone unless you have initiated the call and know with whom
            you are speaking;
          </p>
          <p>
            2. update any changes in addresses or contact Information
            immediately through the proper channel;
          </p>
        </p>
        <br />{' '}
        <p>
          <b>Force Majeure:</b>
        </p>
        <br />{' '}
        <p>
          Notwithstanding anything contained in this Policy or terms of use or
          other terms and condition on the Website or elsewhere, Lifestyle shall
          not be held responsible for any loss, damage or misuse of Your
          Personal Information, if such loss, damage or misuse is attributable
          to a Force Majeure Event (as defined below).
        </p>
        <br />{' '}
        <p>
          &lsquo;Force Majeure Event &lsquo; shall mean any event that is beyond
          the reasonable control of LIFESTYLE and shall include, without
          limitation, sabotage, fire, flood, explosion, acts of God, civil
          commotion, strikes or industrial action of any kind, riots,
          insurrection, war, acts of government, computer hacking, unauthorised
          access to computer, computer system or computer network, computer
          crashes, breach of security and encryption (provided beyond reasonable
          control of LIFESTYLE), power or electricity failure or unavailability
          of adequate power or electricity.
        </p>
        <br />{' '}
        <p>
          While We endeavour to take all reasonable and appropriate steps to
          keep secure any Personal Information which We hold about You and
          prevent unauthorized access, You acknowledge that the internet or
          computer networks are not fully secure and that We cannot provide any
          absolute assurance regarding the security of Your Personal
          Information.
        </p>
        <br />{' '}
        <p>
          <b>Grievance officer:</b>
        </p>
        <br />{' '}
        <p>
          In accordance with Information Technology Act 2000 and rules made
          there under, the name and contact details of the Grievance Officer are
          provided below:
        </p>
        <p>Mr. Sunilkumar J.</p>
        <p>77◦ Town Centre, Building No. 3, West Wing,</p>
        <p>Off HAL Airport Road, Yamlur P.O.,</p>
        <p>Bangalore - 560 037, Karnataka, India</p>
        <p>Phone: 080-41796565 (Extn: 5228)</p>
        <p>Email: Sunilkumar.J@landmarkgroup.in</p>
        <p>Time: Mon – Fri (9:00 - 17:00)</p>
        <br />{' '}
        <p>
          In case you have any discrepancies and grievances in connection with
          this Privacy Policy or Terms of Use or any other terms and conditions
          mentioned on the Website, you may please contact the Grievance Officer
          mentioned above.
        </p>
        <br />
        <p>
          If you have any other questions or clarifications regarding privacy,
          or have questions about practices, please contact us via email at
          help.in@maxfashion.com
        </p>
        <br />
        <p>Subscribe to our awesome emails.</p>
        <br />
        <p>Get our latest offers and news straight in your inbox.</p>
        <br />
        <div className="w-full border bg-black_two "></div>
        <div className="text-center mt-12">
          <u>
            <b>Terms of Use for Self-Checkout Facility</b>
          </u>
        </div>
        <br />
        <br />
        <br />
        <p>
          Lifestyle International Private Limited, Max Retail Division, a
          company incorporated in India under the provisions of Companies Act,
          1956 having its registered office at 77 Town Centre, Building No. 3,
          West Wing, Off HAL Airport Road, Yamlur P.O., Bangalore - 560037
          (referred to herein as “Lifestyle”, “we”, “our” or “us”) is in the
          business of brick and mortar retailing of apparels, accessories,
          furniture etc, through various Brands viz., Lifestyle, Max, Home
          Centre, Easybuy (“Products”).
          <span>
            <b>
              This website provides a facility to customers of Lifestyle (“you”
              “your” or “customer”) to enable self – checkout, generate invoice
              and make payment of goods purchased at the stores of Lifestyle
            </b>
          </span>{' '}
          (“Checkout Services”). All Checkout Services initiated by you on the
          website <span>www.buddy.maxfashion.in</span> (“Website”), shall be at
          your own risk and your usage of the Checkout Services shall be deemed
          as your acceptance to these Terms of Use and Privacy Policy.{' '}
        </p>
        <br />
        <p>
          NOTWITHSTANDING ANY ORAL OR WRITTEN INFORMATION, OPINIONS,
          EVALUATIONS, DESCRIPTIONS OR CONSULTATIONS OF ANY KIND FURNISHED BY
          LIFESTYLE TO THE CONTRARY, YOU SPECIFICALLY AGREE TO THE TERMS SET
          FORTH BELOW.
        </p>
        <br />
        <p>TERMS AND CONDITIONS:</p>
        <br />
        <p>
          These Terms of Use (“Terms”) sets forth the terms and conditions that
          apply only to the Checkout Services provided by Lifestyle. Change in
          law or changes in Lifestyle business may require changes to be made to
          the Terms from time to time (“Revised Terms”). As such, Lifestyle
          encourages you to review the Terms and any other terms and condition
          periodically for any such changes. It is your sole responsibility to
          carefully read, agree with and accept the terms or any other terms and
          condition.
        </p>
        <br />
        <p>
          You agree that Lifestyle makes no warranty or guarantee as to the
          accuracy, comprehensiveness, or correctness of any Product(s) on
          Checkout Services and provides all Checkout Services on an
          &quot;as-is&quot; and “as-available” basis.
        </p>
        <br />
        <p>
          Persons who are &quot;incompetent to contract&quot; under the Indian
          Contract Act, 1872 including minors, un-discharged insolvents etc… or
          otherwise barred by law are not eligible to use the Checkout Services.
          Persons under the age of 18 years cannot transact through or use the
          Checkout Services.{' '}
        </p>
        <br />
        <p>SERVICES; ORDER, PRICING AND PAYMENT:</p>
        <br />
        <p>The Services shall include:</p>
        <br />
        <p>
          Checkout Services i.e., you may scan the barcode of the Product,
          upload into the cart and make payment for the Product through the
          Checkout Services;
        </p>
        <br />
        <p>
          You agree to pay the full amount payable for the Product as indicated
          during the Checkout Services, including charges incurred with that
          order. All prices are displayed and are payable in Indian National
          Rupees.
        </p>
        <br />
        <p>
          From time to time there may be errors in the pricing that appears on
          the Checkout Services or during the order process. There may also be
          errors in transmission resulting in the interruption of your purchase.
          Without admissions, Lifestyle will in good faith try to resolve any
          issues that may arise as a result of such errors. You agree to
          cooperate with Lifestyle to resolve such issues, and you agree that
          Lifestyle shall have full discretion to determine the appropriate
          resolution in such cases.
        </p>
        <br />
        <p>
          While availing any of the payment method(s) available on the Checkout
          Services, we will not be responsible or assume any liability,
          whatsoever in respect of any loss or damage arising directly or
          indirectly to You due to:
        </p>
        <br />
        <p>Lack of authorization for any transaction/s, or</p>
        <p>
          Exceeding the pre-set limit mutually agreed by You and between
          &quot;Bank/s&quot;, or
        </p>
        <p>Any payment issues arising out of the transaction, or</p>
        <p>Decline of transaction for any other reason/s</p>
        <br />
        <p>
          Lifestyle may offer multiple payment options through various
          instrument(s) or mode(s) for the convenience of the customers.
          Lifestyle reserves the right to add or remove or modify the terms and
          conditions for such payment options without prior notice. Without
          prejudice to the aforesaid, usage of any of the above payment options
          shall at all times be subject to rules, regulations and guidelines
          under applicable law and those prescribed by RBI, issuer banks,
          acquiring banks, facility providers and other intermediaries involved
          in the payment process.
        </p>
        <br />
        <p>
          All payment transactions are subject to validation by the issuer as
          applicable. If the issuer of your payment instrument(s) refuses to
          authorise payment, Lifestyle has the right to cancel the order.
          Lifestyle cannot be held responsible if this should result in a delay
          in dispatching your goods/Products.
        </p>
        <br />
        <p>
          Lifestyle reserves the right to refuse to process transactions by
          buyers with a prior history of questionable charges including without
          limitation breach of any agreements by buyer with Lifestyle or
          breach/violation of any law or any charges imposed by issuing bank or
          breach of any policy.
        </p>
        <br />
        <p>
          All billing and registration information provided must be truthful and
          accurate. Providing any untruthful or inaccurate information
          constitutes a breach of these Terms. By confirming your purchase at
          the end of the process, you agree to accept and pay for the item/s
          requested.
        </p>
        <br />
        <p>
          Certain orders may constitute improper use of the Checkout Services.
          Lifestyle reserves the right, at its sole discretion, to refuse or
          cancel any order for any reason. Your Account may also be restricted
          or terminated for any reason, at Lifestyle sole discretion.
        </p>
        <br />
        <p>
          In the event that a Product is listed at an incorrect price due to an
          error in pricing, Lifestyle shall have the right, at Lifestyle
          discretion, to refuse or cancel any orders placed for that Product. In
          the event that a Product is mispriced, Lifestyle may, at Lifestyle’s
          discretion, either contact you for instructions or cancel your order
          and notify you of such cancellation.
        </p>
        <br />
        <p>
          Lifestyle reserves the right, at its sole discretion and without prior
          notice, to limit the quantity / value of items purchased per person
          per household or per order. These restrictions may be applicable to
          order placed by same account, the same credit card and also to orders
          that use the same billing and/or shipping address.
        </p>
        <br />
        <p>RETURNS </p>
        <br />
        <p>
          Lifestyle wants you to be pleased with your purchase, and so if for
          any reason you are not completely satisfied, Lifestyle will accept
          return of your purchase subject to the following conditions:{' '}
        </p>
        <br />
        <p>
          a. Merchandise to be exchanged should be intact, unused, in its
          original packaging and with barcode tags.
        </p>
        <p>
          b. Exchange is permitted only at the store from where the merchandise
          is purchased.
        </p>
        <p>
          c. Original invoice is required with the merchandise to be exchanged.
        </p>
        <p>
          d. No Cash refunds shall be given. Only a credit note shall be issued
          with a validity of 90 days (from the date of issue of the credit
          note).
        </p>
        <p>
          e. Kindly note that no return or exchange will be accepted for the
          following : Altered garments, Used merchandise, Undergarments and
          Socks and Discounted Merchandise
        </p>
        <br />
        <p>LIMITATION OF LIABILITY AND INDEMNITY </p>
        <br />
        <p>
          You agree, to the fullest extent permitted by law, to indemnify and
          hold Lifestyle , its directors, officers, employees, affiliates, group
          companies, shareholders, agents, contractors, and licensors harmless
          with respect to any claims arising out of your breach of these Terms,
          your use of the Website or the Checkout Services, your non-compliance
          with applicable laws or regulations in the jurisdiction in which you
          are accessing the Website or the Services, or any action taken by
          Lifestyle as part of its investigation of a suspected violation of
          these Terms or as a result of its finding or decision that a violation
          of these Terms has occurred. You agree to defend, indemnify and hold
          harmless Lifestyle and its affiliates and group companies and from and
          against any and all claims, damages, costs and expenses, including
          attorneys&apos; fees, arising from or related any breach by you of
          these Terms or any other terms and conditions on the Website.
        </p>
        <br />
        <p>
          UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL OR EQUITABLE THEORY, WHETHER
          IN TORT, CONTRACT, STRICT LIABILITY OR OTHERWISE, SHALL LIFESTYLE OR
          ANY OF ITS AFFILIATES, GROUP COMPANIES, EMPLOYEES, DIRECTORS,
          OFFICERS, AGENTS, VENDORS OR SUPPLIERS BE LIABLE TO YOU OR TO ANY
          OTHER PERSON FOR ANY INDIRECT, SPECIAL, INCIDENTAL OR CONSEQUENTIAL
          LOSSES OR DAMAGES OF ANY NATURE, INCLUDING, WITHOUT LIMITATION,
          DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, LOSS OF DATA, WORK
          STOPPAGE, BUSINESS INTERRUPTION, ACCURACY OF RESULTS, OR COMPUTER
          FAILURE OR MALFUNCTION, EVEN IF AN AUTHORISED REPRESENTATIVE OF
          LIFESTYLE HAS BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY
          OF SUCH DAMAGES, ARISING OUT OF OR IN CONNECTION WITH (I) THE USE OF
          OR INABILITY TO USE THE WEBSITE; (II) YOUR USE OF OR RELIANCE ON THE
          WEBSITE, ANY INFORMATION, HYPERLINKS OR CONTENT CONTAINED THEREIN, OR
          SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THIS
          WEBSITE; (III) YOUR PROVISION OF INFORMATION, PERSONAL OR OTHERWISE,
          TO LIFESTYLE; (IV) THE PROVISION OF SERVICES BY LIFESTYLE OR; OR (V)
          ACTS OR NEGLIGENCE ON THE PART OF LIFESTYLE. IN NO EVENT WILL
          LIFESTYLE BE LIABLE FOR ANY LOSSES, DAMAGES OR EXPENSES IN EXCESS OF
          THE AMOUNT PAID BY YOU TOWARDS THE PRICE OF THE PRODUCT IN RESPECT TO
          WHICH THE CLAIM AROSE. YOU HEREBY RELEASE US FROM ANY AND ALL
          OBLIGATIONS, LIABILITIES AND CLAIMS IN EXCESS OF THIS LIMITATION
        </p>
        <br />
        <p>GENERAL</p>
        <br />
        <p>
          If any provision of these Terms and any other terms and condition is
          held to be unenforceable for any reason, such provision shall be
          reformed only to the extent necessary to make it enforceable and the
          other terms of these Terms and any other terms and condition shall
          remain in full force and effect. The failure of Lifestyle to act with
          respect to a breach of these Terms by you or others does not
          constitute a waiver and shall not limit Lifestyle rights with respect
          to such breach or any subsequent breaches.
        </p>
        <br />
        <p>
          These terms and any other terms and condition shall be governed by the
          laws of India and any disputes shall be subject to the exclusively
          jurisdiction of courts at Bengaluru.
        </p>
        <br />
        <p>
          You acknowledge and agree that no joint venture, partnership,
          employment, or agency relationship exists between you, Lifestyle and
          Lifestyle as a result of your use of this Website or Checkout
          Services.
        </p>
        <br />
        <p>
          A reference to the Website in these Terms includes the website URL
          www.buddy.lifestylestores.com and any successor website URLs.
        </p>
        <br />
        <p>
          These Terms (i) constitute the entire agreement between you and
          Lifestyle with respect to the Checkout Services and supersedes any
          previous oral or written arrangements or understandings relating
          thereto, (ii) (iv) may not be assigned or resold, in whole or in part,
          directly or indirectly, by operation of law or otherwise, by you.
        </p>
        <br />
        <p>
          Lifestyle shall be not held liable for any delay or failure in
          performance of any part of these Terms from any cause beyond our
          control and without our fault or negligence, such as acts of God, acts
          of civil or military authority, current laws and regulations and
          changes thereto, embargoes, epidemics, war, terrorist acts, riots,
          insurrections, fires, explosions, earthquakes, nuclear accidents,
          floods, strikes, power blackouts, volcanic action, pandemic, political
          unrest, other major environmental disturbances, unusually severe
          weather conditions, acts of hackers and other illegal activities of
          third parties, inability to secure products or Services of other
          persons or transportation facilities, or acts or omissions of
          transportation or telecommunications common carriers or acts,
          omissions, overloading or slowdowns over the Internet or any third
          party Internet service providers.
        </p>
        <br />
        <p>CUSTOMER CARE:</p>
        <br />
        <p>Mr. Sunilkumar J.</p>
        <p>77◦ Town Centre, Building No. 3, West Wing,</p>
        <p>Off HAL Airport Road, Yamlur P.O.,</p>
        <p>Bangalore - 560 037, Karnataka, India</p>
        <p>Phone: 080-41796565 (Extn: 5228)</p>
        <p>Email: Sunilkumar.J@landmarkgroup.in</p>
        <p>Time: Mon – Fri (9:00 - 17:00)</p>
        <p>
          Thank you for your cooperation. We hope you find this Website helpful
          and convenient to use.
        </p>
        <br />
        <div className="w-full border bg-black_two "></div>
        <div className=" mt-2">About Max Fashion:</div>
        <p>
          Max Fashion, known for ‘everyday fashion’ is the biggest fashion brand
          across the Middle East and India. Opening its first store in the
          Middle East in 2004, the brand has grown at a phenomenal pace and is
          now present in 19 countries. In India, currently, it has more than
          370+ stores with presence across 150+ cities; it has become the
          biggest fashion brand not only in the Middle East but also in India in
          the short period it has been here.{' '}
        </p>
        <br />
        <p>
          Max Fashion’s brand vision is to “democratize fashion” by offering
          global fashion trends and wide range at amazingly affordable prices.
          It enjoys universal appeal across young families as well as
          millennials, who are not only fashion conscious but tech-savvy,
          because of a well-balanced portfolio across Apparel, Footwear &
          Accessories for Men, Women & Kids. With over 20,000 new designs across
          8 seasons every year, consumers get access to truly fast fashion at
          amazingly low prices.
        </p>
        <br />
        <p>
          Max Fashion is a true Omni-channel brand with first in industry
          capabilities like “Click & Collect”, “Ship from Store”, “Return to
          Store” & “Chat & Shop”, apart from offering outstanding Online
          shopping experience through the maxfashion.in website as well as an
          engaging app which is enjoyed by millions of consumers.{' '}
        </p>
        <br />
        <p>
          For more information, visit{' '}
          <a
            href=" https://www.maxfashion.in"
            target="_blank"
            rel="noopener noreferrer">
            <u> https://www.maxfashion.in</u>
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsAndCondition;
